<div [formGroup]="form">
  <div class="form-check">
    <input
      type="checkbox"
      class="filled-in form-check-input"
      #checkbox
      [formControlName]="settings.formControlName"
      [checked]="settings.checked"
      [id]="settings.idName"
      (change)="valueChange()"
      (focus)="onFocusEvent($event)"
      (click)="onClickEvent($event)"
      (blur)="onBlurEvent($event)"
    />
    <label [for]="settings.idName">
      <div [innerHTML]="settings.label" class="rider"></div>
    </label>
  </div>
  <p class="text-danger">{{ errorMessage }}</p>
</div>
